/* https://github.com/nghuuphuoc/bootstrapvalidator/blob/master/src/js/validator/isin.js */

export function checkIsinValidity(value: string | undefined | null) {
  if (value === '' || !value) {
    return false;
  }

  const isinRegex = /[A-Z]{2,2}[A-Z0-9]{9,9}[0-9]{1,1}/g;
  if (isinRegex.test(value)) {
    let converted = '';
    const { length } = value;
    // Convert letters to number
    for (let i = 0; i < length - 1; i++) {
      const c = value.charCodeAt(i);
      converted += c > 57 ? (c - 55).toString() : value.charAt(i);
    }

    let digits = '';
    const n = converted.length;
    const group = n % 2 !== 0 ? 0 : 1;
    for (let i = 0; i < n; i++) {
      digits += (parseInt(converted[i], 10) * (i % 2 === group ? 2 : 1)).toString().concat('');
    }

    let sum = 0;
    for (let i = 0; i < digits.length; i++) {
      sum += parseInt(digits.charAt(i), 10);
    }
    sum = (10 - (sum % 10)) % 10;
    return sum.toString().concat('') === value.charAt(length - 1);
  } else {
    return false;
  }
}
